import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import { NotificationProvider } from '../context/NotificationContext';
import PrivateRoute from './PrivateRoute';
import RoleBasedRoute from '../components/RoleBasedRoute';
import { isMcpAdminEnabled } from '../utils/mcpAdmin';
import { isNotificationsEnabled } from '../utils/notifications';

import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import CustomersPage from '../pages/CustomersPage';
import QueriesPage from '../pages/QueriesPage';
import FollowupsPage from '../pages/FollowupsPage';
import BookingsPage from '../pages/BookingsPage';
import CreatePackagePage from '../pages/CreatePackagePage';
import CreateQuotationPage from '../pages/CreateQuotationPage';
import HotelsPage from '../pages/HotelsPage';
import ActivitiesPage from '../pages/ActivitiesPage';
import PackagesPage from '../pages/PackagesPage';
import AttendancePage from '../pages/AttendancePage';
import TelecallingPage from '../pages/TelecallingPage';
import McpAdminPage from '../pages/McpAdminPage';
import SalesCopilotPage from '../pages/SalesCopilotPage';

function NotificationFeature({ children, enabled }: { children: React.ReactNode; enabled: boolean }) {
  return enabled ? <NotificationProvider>{children}</NotificationProvider> : <>{children}</>;
}

const AppRoutes = () => {
  const mcpAdminEnabled = isMcpAdminEnabled();
  const notificationsEnabled = isNotificationsEnabled();

  return (
   <AuthProvider>
    <Router>
      <NotificationFeature enabled={notificationsEnabled}><Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />
        <Route path="/dsr" element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewDashboard"><DashboardPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewCustomers"><CustomersPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/queries" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewQueries"><QueriesPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/sales-copilot" element={<PrivateRoute><SalesCopilotPage /></PrivateRoute>} />
        <Route path="/followups" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewFollowups"><FollowupsPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/bookings" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewBookings"><BookingsPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/telecalling" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewTelecalling"><TelecallingPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/packages" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewPackages"><PackagesPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/package/builder" element={<PrivateRoute><RoleBasedRoute requiredPermission="canCreatePackages"><CreatePackagePage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/quotation/builder" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewQueries"><CreateQuotationPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/hotels" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewHotels"><HotelsPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/activities" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewHotels"><ActivitiesPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/attendance" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewAttendance"><AttendancePage /></RoleBasedRoute></PrivateRoute>} />
        {mcpAdminEnabled && (
          <Route path="/admin/mcp" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewMcpAdmin" fallbackPath="/dashboard"><McpAdminPage /></RoleBasedRoute></PrivateRoute>} />
        )}
      </Routes></NotificationFeature>
    </Router>
   </AuthProvider>
  );
};

export default AppRoutes;
